export default "__VITE_ASSET__BJFfLL5n__"